import { useState } from 'react'

const useProductDetailDrawer = () => {
  const [showProductDetailDrawer, setShowProductDetailDrawer] = useState(false)
  const [product, setProduct] = useState(null)

  const openProductDetailDrawer = product => {
    setShowProductDetailDrawer(true)
    setProduct(product)
  }

  const closeProductDetailDrawer = () => {
    setShowProductDetailDrawer(false)
    setProduct(null)
  }

  return {
    showProductDetailDrawer,
    setShowProductDetailDrawer,
    openProductDetailDrawer,
    closeProductDetailDrawer,
    selectedProduct: product,
  }
}

export default useProductDetailDrawer
